/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from "@apollo/client";
import { SUBMISSION_APPLICATION_FORM } from "@app/apollo/queries";
import OpportunityFormViewer from '@organisms/opportunities/OpportunityFormViewer';
import { useTranslation } from '@app/config/i18n';
import { SectionBox, ApplicationMeta } from './style';

const SubmissionsForm = ({ opportunity, showApplicationForm, setShowApplicationForm }) => {
    const { t } = useTranslation(['common']);
    const [showTerms, setShowTerms] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);

    const { data: { submissionApplicationForm } = {}, loading: submissionApplicationFormLoading } = useQuery(SUBMISSION_APPLICATION_FORM, {
        variables: {
            slug: opportunity.slug,
        },
    });

    const [initialValue, setInitialValue] = useState({
        opportunity: opportunity.slug,
        fields: {},
        members: [],
        recaptcha: null,
    });

    return (
        !submissionApplicationFormLoading &&
        <>
            <SectionBox display='flex' justifyContent='center'>
                <ApplicationMeta variant="h5" weight="600">
                    {t('common:create_submission')}
                </ApplicationMeta>
            </SectionBox>
            <OpportunityFormViewer
                myOpportunity={opportunity}
                opportunitySlug={opportunity.slug}
                applicationForm={submissionApplicationForm}
                loading={submissionApplicationFormLoading}
                initialValue={initialValue}
                setInitialValue={setInitialValue}
                showTerms={showTerms}
                setShowTerms={setShowTerms}
                agreeTerms={agreeTerms}
                setAgreeTerms={setAgreeTerms}
                showApplicationForm={showApplicationForm}
                setShowApplicationForm={setShowApplicationForm}
            />
        </>

    );
};

SubmissionsForm.propTypes = {
    opportunity: PropTypes.object,
    showApplicationForm: PropTypes.bool.isRequired,
    setShowApplicationForm: PropTypes.func.isRequired
};

SubmissionsForm.defaultProps = {
    opportunity: null,
};

export default SubmissionsForm;
